import request from "@/utils/request";

//跳转微信授权登录界面
export function renderVxModel() {
  return request({
    url: "/api/business/C_customers/render",
    method: "post",
    // data,
  });
}

// 获取微信用户信息
export function GetVxUserMes(data) {
  return request({
    url: "/api/business/C_customers/callback",
    method: "post",
    data,
  });
}

// 根据token获得用户信息
export function GetUserMesByToken() {
  return request({
    url: "/api/business/C_customers/userinfo",
    method: "get",
  });
}

// 黑名单校验（用于线上购买、许可申请、发票申请等操作前拦截）
export function checkBlacklist(data) {
  return request({
    url: "/api/business/C_customers/checkBlacklist",
    method: "post",
    data,
  });
}

// 根据手机号获取客户基本信息
export function getCustomerByPhone(phone) {
  return request({
    url: `/api/business/C_customers/byPhone/${phone}`,
    method: "get",
  });
}

// 根据token获得用户信息
export function GetRetailerMesByToken() {
  return request({
    url: "/api/business/C_retailers/userinfo",
    method: "get",
  });
}

// 发送登录验证码
export function SendVerCode(data) {
  return request({
    url: "/api/business/C_customers/sendVerCode?phone=" + data,
    method: "post",
  });
}

// 微信登录同时绑定手机号码
export function LoginByWx(data) {
  return request({
    url: "/api/business/C_customers/loginByWx",
    method: "post",
    data,
  });
}

// 短信登录
export function LoginByPhone(data) {
  return request({
    url: "/api/business/C_customers/loginByPhone",
    method: "post",
    data,
  });
}

// 验证码检验
export function CheckVerCode(data, code) {
  return request({
    url:
      "/api/business/C_customers/checkVerCode?phone=" +
      data +
      "&verCode=" +
      code,
    method: "post",
  });
}

// 分销商短信登录
export function LoginByPhoneRetailer(data) {
  return request({
    url: "/api/business/C_retailers/loginByPhone",
    method: "post",
    data,
  });
}

// 发送登录验证码
export function SendVerCodeRetailer(data) {
  return request({
    url: "/api/business/C_retailers/checkVerCode?phone=" + data,
    method: "post",
  });
}

// 申请许可证
export function ApplyLicense(data) {
  return request({
    url: "/api/business/C_license/applyLicense",
    method: "post",
    data,
  });
}

// 新客户线下许可申请流程，保留旧 ApplyLicense 不变
export function getApplyLicense2DogProducts(data) {
  return request({
    url: "/api/business/C_license/applyLicense2/dog-products",
    method: "get",
    data,
  });
}

// 仅按加密狗查询绑定产品和许可规则，手机号只在最终申请时识别申请人
export function getApplyLicense2DogProductsByDog(data) {
  return request({
    url: "/api/business/C_license/applyLicense2/dog-products-by-dog",
    method: "get",
    data,
  });
}

export function getApplyLicense2DogProductsByFamily(data) {
  return request({
    url: "/api/business/C_license/applyLicense2/dog-products-by-family",
    method: "get",
    data,
  });
}

// 查询加密狗最近一次烧制的许可天数（null 表示无烧制记录或天数为空，-1 表示永久狗）
export function getApplyLicense2DogBurnDays(data) {
  return request({
    url: "/api/business/C_license/applyLicense2/dog-burn-days",
    method: "get",
    data,
  });
}

export function applyLicense2(data) {
  return request({
    url: "/api/business/C_license/applyLicense2",
    method: "post",
    data,
  });
}

export function getNoDogLicenseProducts(pid) {
  return request({
    url: "/api/business/C_license/applyLicense-no-dog/products",
    method: "get",
    data: { pid },
  });
}

export function getNoDogLicenseCustomer(phone) {
  return request({
    url: "/api/business/C_license/applyLicense-no-dog/customer",
    method: "get",
    data: { phone },
  });
}

export function applyNoDogLicense(data) {
  return request({
    url: "/api/business/C_license/applyLicense-no-dog",
    method: "post",
    data,
  });
}

export function getNoDogLicenseApplications(phone) {
  return request({
    url: "/api/business/C_license/applyLicense-no-dog/applications",
    method: "get",
    data: { phone },
  });
}
// 免申请直接生成许可证
export function createPermitLicense(data) {
  return request({
    url: "/api/business/C_license/createPermitLicense",
    method: "post",
    data,
  });
}

// 判断许可码是否可用
export function checkPermit(data) {
  return request({
    url: `/api/business/C_permitcode/getList`,
    method: "post",
    data,
  });
}
